export default __webpack_public_path__ + "796bbf738a38bb1c81b59a41b776154a.jpg";